<template>
  <div
    v-if="company.company_key !== 'lloydsestates' && company.company_key !== 'thepropertycloud'"
    style="z-index: 999 !important"
    :class="{
      'position-unset tw-fixed tw-left-0 tw-top-0 tw-z-50 tw-flex tw-w-full tw-flex-col': variants.HEADER_2 === variant,
    }"
  >
    <nav
      :class="[
        'tw-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-px-6 tw-text-center tw-duration-300',
        'tw-fixed tw-left-0 tw-top-0 tw-z-50 tw-w-full tw-py-4',
        { 'tw-relative !tw-py-2': variants.HEADER_2 === variant },
      ]"
      :style="`z-index: 999!important;
      ${vars.borderBool ? `border-bottom: 1px solid var(--c-secondary);` : ''}
    ${isScrolled || vars.fixedColorBool ? `background-color: var(--c-${vars.backgroundColor});` : 'background-color: transparent;'}
    color: var(--c-${vars.textColor});
`"
    >
      <div class="tw-z-40 tw-mr-auto tw-flex tw-justify-start tw-pt-2 xl:tw-hidden">
        <button  id="menu-button" class="focus:outline-none tw-flex" @click="toggleMenu" aria-label="Open menu">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M32 13H0V11H32V13ZM32 20.984H10V19H32V20.984Z" fill="white" />
          </svg>
        </button>
      </div>
      <div class="tw-mr-auto tw-max-w-56 tw-justify-center">
        <nuxt-link
          style="padding: 0 !important; border: none !important; border-radius: 0 !important"
          to="/"
          :external="true"
        >
          <NuxtImg :src="company.logo" alt="logo" />
        </nuxt-link>
      </div>
      <div>
        <div class="tw-ml-4 tw-hidden xl:tw-block">
          <ul class="tw-flex tw-gap-8 tw-align-middle lg:tw-shrink">
            <li
              v-for="(menuGroup, groupIndex) in allMenu[0]"
              :key="`menuGroupIndex-${groupIndex}`"
              class="tw-group tw-relative tw-py-8"
            >
              <div class="tw-flex tw-items-center tw-justify-center">
                <nuxt-link
                  :external="true"
                  :to="menuGroup.url"
                  :target="menuGroup.is_open_new_tab ? '_blank' : ''"
                  class="n-link tw-duration-300 hover:tw-text-[var(--c-secondary)]"
                >
                  <template v-if="variants.HEADER_1 === variant">{{ menuGroup.name }}</template>
                  <h6 v-if="variants.HEADER_2 === variant">
                    {{ menuGroup.name }}
                  </h6>
                </nuxt-link>
                <span
                  v-if="menuGroup.has_sub_menu"
                  class="nc-icon-chevron-down sub-menu-arrow theme3-menu-link tw-ml-2"
                ></span>
              </div>
              <ul
                v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
                class="sub_menu tw-absolute tw-mt-7 tw-hidden tw-rounded-sm tw-bg-white tw-px-6 tw-py-4 tw-text-left tw-text-black tw-shadow-md group-hover:!tw-block"
                style="border-radius: var(--rounded-sm)"
              >
                <li
                  v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
                  :key="`${subMenuIndex}-subMenu-${groupIndex}`"
                  class="tw-w-[220px] tw-py-4"
                  style="border-color: var(--c-border)"
                  :class="{
                    'tw-border-b': subMenuIndex !== menuGroup.sub_menus.length - 1 && variants.HEADER_2 != variant,
                  }"
                >
                  <nuxt-link
                    class="n-link tw-block tw-px-4 tw-py-2 hover:tw-ml-4 hover:tw-text-[var(--c-secondary)]"
                    :external="true"
                    :to="subMenu.url"
                    :target="subMenu.is_open_new_tab ? '_blank' : ''"
                  >
                    <template v-if="variants.HEADER_1 === variant">{{ subMenu.name }}</template>
                    <h6 v-if="variants.HEADER_2 === variant">
                      {{ subMenu.name }}
                    </h6>
                  </nuxt-link>
                </li>
              </ul>
            </li>

            <li class="tw-py-8">
              <nuxt-link :to="vars.buttonLinkUrl" :class="`n-${vars.buttonTypeText}`" :external="true">{{
                vars.buttonLabelText
              }}</nuxt-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <NavigationBanner v-if="variants.HEADER_2 === variant && navigationBanner.isVisibleBool" :vars="navigationBanner" />
  </div>

  <div
    v-if="variants.HEADER_1 === variant"
    class="tw-fixed tw-left-0 tw-z-30 tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-overflow-y-auto tw-duration-300"
    :class="menuVisible ? 'tw-top-0' : '-tw-top-full'"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: var(--c-${vars.textColor});`"
  >
    <ul class="tw-mt-20 tw-flex tw-w-full tw-flex-col tw-items-center tw-space-y-4 tw-px-12">
      <li v-for="(menuGroup, groupIndex) in allMenu[0]" :key="`menuGroupIndex-${groupIndex}`" class="tw-w-full">
        <div class="tw-flex tw-w-full tw-items-center tw-gap-2 tw-py-3" @click="toggleSubMenu(groupIndex)">
          <nuxt-link
            :external="true"
            :to="menuGroup.has_sub_menu ? '' : menuGroup.url"
            :target="menuGroup.is_open_new_tab ? '_blank' : ''"
            class="n-link tw-text-lg tw-font-medium"
          >
            {{ menuGroup.name }}
          </nuxt-link>
          <span
            v-if="menuGroup.has_sub_menu"
            class="nc-icon-chevron-down sub-menu-arrow theme3-menu-link"
            :class="{ 'tw-rotate-180': openSubMenu === groupIndex }"
          ></span>
        </div>
        <ul
          v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
          class="tw-ml-4 tw-space-y-2 tw-overflow-hidden tw-transition-all tw-duration-300"
          :class="openSubMenu === groupIndex ? 'tw-max-h-96' : 'tw-max-h-0'"
        >
          <li
            v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
            :key="`${subMenuIndex}-subMenu-${groupIndex}`"
            class="tw-py-2"
          >
            <nuxt-link
              class="n-link tw-block tw-px-2 tw-py-1 hover:tw-text-[var(--c-secondary)]"
              :external="true"
              :to="subMenu.url"
              :target="subMenu.is_open_new_tab ? '_blank' : ''"
            >
              {{ subMenu.name }}
            </nuxt-link>
          </li>
        </ul>
      </li>
      <li class="tw-w-full tw-py-3">
        <nuxt-link
          :to="vars.buttonLinkUrl"
          class="tw-block tw-text-center"
          :class="`n-${vars.buttonTypeText}`"
          :external="true"
          >{{ vars.buttonLabelText }}</nuxt-link
        >
      </li>
    </ul>
  </div>

  <div
    v-if="variants.HEADER_2 === variant"
    class="tw-fixed tw-left-0 tw-top-0 tw-h-full tw-w-[90%] tw-overflow-y-auto tw-bg-white tw-text-black tw-duration-300"
    style="z-index: 1000"
    :class="menuVisible ? 'tw-translate-x-0' : '-tw-translate-x-[101%]'"
  >
    <ul class="tw-flex tw-flex-col tw-items-start tw-space-y-4 tw-px-6 tw-pt-12">
     <li><span
        @click="toggleMenu"
        class="tw-absolute tw-right-10 tw-top-10 tw-cursor-pointer tw-rounded-full tw-border-2 tw-p-4"
        ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15.2806 14.2193C15.3502 14.289 15.4055 14.3717 15.4432 14.4628C15.4809 14.5538 15.5003 14.6514 15.5003 14.7499C15.5003 14.8485 15.4809 14.9461 15.4432 15.0371C15.4055 15.1281 15.3502 15.2109 15.2806 15.2806C15.2109 15.3502 15.1281 15.4055 15.0371 15.4432C14.9461 15.4809 14.8485 15.5003 14.7499 15.5003C14.6514 15.5003 14.5538 15.4809 14.4628 15.4432C14.3717 15.4055 14.289 15.3502 14.2193 15.2806L7.99993 9.06024L1.78055 15.2806C1.63982 15.4213 1.44895 15.5003 1.24993 15.5003C1.05091 15.5003 0.860034 15.4213 0.719304 15.2806C0.578573 15.1398 0.499512 14.949 0.499512 14.7499C0.499512 14.5509 0.578573 14.36 0.719304 14.2193L6.93962 7.99993L0.719304 1.78055C0.578573 1.63982 0.499512 1.44895 0.499512 1.24993C0.499512 1.05091 0.578573 0.860034 0.719304 0.719304C0.860034 0.578573 1.05091 0.499512 1.24993 0.499512C1.44895 0.499512 1.63982 0.578573 1.78055 0.719304L7.99993 6.93962L14.2193 0.719304C14.36 0.578573 14.5509 0.499512 14.7499 0.499512C14.949 0.499512 15.1398 0.578573 15.2806 0.719304C15.4213 0.860034 15.5003 1.05091 15.5003 1.24993C15.5003 1.44895 15.4213 1.63982 15.2806 1.78055L9.06024 7.99993L15.2806 14.2193Z"
            fill="#222222"
          />
        </svg>
      </span></li> 
      <li v-for="(menuGroup, groupIndex) in allMenu[0]" :key="`menuGroupIndex-${groupIndex}`" class="tw-w-full">
        <div class="tw-flex tw-w-full tw-items-center tw-gap-2 tw-py-3" @click="toggleSubMenu(groupIndex)">
          <nuxt-link
            :external="true"
            :style="variants.HEADER_2 === variant ? 'color: var(--c-text-primary);' : ''"
            :to="menuGroup.has_sub_menu ? '#' : menuGroup.url"
            :target="menuGroup.is_open_new_tab ? '_blank' : ''"
            class="n-link tw-text-lg tw-font-medium tw-duration-300 hover:tw-text-[var(--c-secondary)]"
          >
            <h6>{{ menuGroup.name }}</h6>
          </nuxt-link>
          <span
            v-if="menuGroup.has_sub_menu"
            class="nc-icon-chevron-down sub-menu-arrow theme3-menu-link"
            :class="{ 'tw-rotate-180': openSubMenu === groupIndex }"
          ></span>
        </div>
        <ul
          v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
          class="tw-ml-4 tw-space-y-2 tw-overflow-hidden tw-transition-all tw-duration-300"
          :class="openSubMenu === groupIndex ? 'tw-max-h-96' : 'tw-max-h-0'"
        >
          <li
            v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
            :key="`${subMenuIndex}-subMenu-${groupIndex}`"
            class="tw-py-2"
          >
            <nuxt-link
              class="n-link tw-block tw-px-2 tw-py-1 hover:tw-text-[var(--c-secondary)]"
              :external="true"
              :to="subMenu.url"
              :style="variants.HEADER_2 === variant ? 'color: var(--c-text-primary);' : ''"
              :target="subMenu.is_open_new_tab ? '_blank' : ''"
            >
              <h6>{{ subMenu.name }}</h6>
            </nuxt-link>
          </li>
        </ul>
      </li>
      <li class="tw-w-full tw-py-3">
        <nuxt-link
          :to="vars.buttonLinkUrl"
          class="tw-float-start tw-block tw-text-center"
          :class="`n-${vars.buttonTypeText}`"
          :external="true"
          >{{ vars.buttonLabelText }}</nuxt-link
        >
      </li>
    </ul>
  </div>

  <!-- ================= HEADER_3 (YENİ) ================= -->
  <div
    v-if="variants.HEADER_3 === variant"
    class="position-unset navbar tw-absolute tw-left-0 tw-top-0 tw-z-50 tw-flex tw-w-full tw-items-center tw-justify-between !tw-bg-opacity-90 tw-px-6 tw-py-6 tw-transition-all tw-duration-300 md:tw-px-20 md:tw-py-8 xl:tw-px-32"
    :class="{ 'scrolled !tw-fixed': isScrolled }"
    :style="`
    ${
      menuVisible
        ? 'background-color: var(--c-secondary); color: var(--c-secondary);'
        : isScrolled || vars.fixedColorBool
          ? 'background-color: var(--c-secondary); color: var(--c-text-primary);'
          : 'background-color: transparent;'
    }
    color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'};
    z-index: 1001;
  `"
  >
    <!-- Sol Butonlar - Menü açıksa gizle -->
    <div class="tw-hidden tw-gap-4 lg:tw-flex">
      <nuxt-link
        v-for="(button, index) in buttons"
        :key="`button-${index}`"
        :class="[
          buttons.length >= 2 ? '' : 'tw-w-auto',
          menuVisible || isScrolled ? 'n-primary' : `n-${button.button_type}`,
          'tw-uppercase',
        ]"
        :to="button.button_link || '/'"
        :external="true"
      >
        {{ button.button_label }}
      </nuxt-link>
    </div>

    <!-- Logo -->
    <nuxt-link
      to="/"
      :external="true"
      :class="[
        'n-link tw-transition-all tw-duration-1000 tw-ease-in-out',
        'md:tw-absolute md:tw-left-1/2 md:tw--translate-x-1/2',
      ]"
    >
      <template v-if="company.company_key === 'harrisonshomes'">
        <div class="tw-w-40 md:tw-w-64">
          <img :src="logo" :style="`width: 100%;`" />
        </div>
      </template>
      <template v-else>
        <div class="tw-w-32 tw-max-w-44">
          <LibraryImage :src="logo" :h-ratio="2" :w-ratio="3" />
        </div>
      </template>
    </nuxt-link>

    <!-- Sağ Burger Menü (v3’e özel) -->
    <button
      class="icon burger-menu tw-border-[1px]"
      @click="toggleBurgerMenuV3"
      :style="`
    border-color: var(--white);
    color: var(--white) !important;
  `"
    >
      <span :style="`background: var(--white);`"></span>
      <span :style="`background: var(--white);`"></span>
    </button>
  </div>

  <div
    v-if="variants.HEADER_3 === variant && menuVisible"
    class="nav-menu tw-fixed tw-inset-0 tw-z-40 tw-flex tw-flex-col tw-items-center tw-justify-between tw-overflow-y-auto !tw-bg-opacity-90 tw-pt-32"
    :style="`background-image: url('${vars.backgroundImage}'); background-size: cover; background-position: center; background-color: var(--c-${vars.backgroundColor})`"
  >
    <!-- Menü -->
    <div
      class="tw-flex tw-h-[70vh] tw-flex-col tw-items-start tw-justify-center tw-overflow-auto tw-px-2 xl:tw-h-screen"
    >
      <nav
        class="tw-max-h-full tw-overflow-auto tw-pb-12 lg:tw-pb-32"
        :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--white)'}`"
      >
        <ul class="tw-flex tw-flex-col tw-gap-4">
          <li
            v-for="(menuGroup, groupIndex) in allMenu[0]"
            :key="`menuGroupIndex-${groupIndex}`"
            class="nav-item tw-group tw-relative tw-duration-300"
            :style="`animation-delay: ${groupIndex * 0.2}s;`"
          >
            <div
              class="tw-flex tw-items-center tw-justify-start lg:tw-justify-center"
              @click="toggleSubMenu(groupIndex)"
            >
              <nuxt-link
                :to="menuGroup.has_sub_menu ? '' : menuGroup.url"
                :target="menuGroup.is_open_new_tab ? '_blank' : ''"
                :external="true"
                class="n-link tw-duration-400 tw-text-start hover:tw-text-[var(--c-primary)] xl:tw-text-center"
              >
                <h2 class="tw-text-white tw-duration-300 hover:tw-text-[var(--c-primary)]">{{ menuGroup.name }}</h2>
              </nuxt-link>
            </div>
            <!-- Sub Menu -->
            <ul
              v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
              class="tw-overflow-hidden tw-transition-all tw-duration-1000 tw-ease-in-out"
              :class="openSubMenu === groupIndex ? 'tw-max-h-96' : 'tw-max-h-0'"
            >
              <li
                v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
                :key="`${subMenuIndex}-subMenu-${groupIndex}`"
                class="tw-pb-2 tw-pt-0 tw-text-center"
              >
                <nuxt-link
                  class="n-link tw-block tw-duration-300 hover:!tw-text-[var(--c-primary)]"
                  :external="true"
                  :to="subMenu.url"
                  :target="subMenu.is_open_new_tab ? '_blank' : ''"
                  :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--white)'}`"
                >
                  <h6 class="tw-text-white tw-duration-300 hover:tw-text-[var(--c-primary)]">{{ subMenu.name }}</h6>
                </nuxt-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      <nuxt-link
        v-if="buttons.length"
        :to="buttons[0].button_link || '/'"
        :external="true"
        class="n-primary tw-mt-2 tw-flex tw-w-auto tw-items-start lg:tw-hidden"
      >
        {{ buttons[0].button_label }}
      </nuxt-link>
    </div>

    <!-- Mobilde buton -->
    <div class="tw-flex tw-w-full tw-justify-start tw-px-6 tw-pb-12 lg:tw-hidden"></div>
  </div>

  <!-- =============== /HEADER_3 (YENİ) =============== -->

  <!-- ================= HEADER_4 (YENİ) ================= -->
  <div
    v-if="variants.HEADER_4 === variant"
    class="position-unset navbar tw-absolute tw-left-0 tw-top-0 tw-z-50 tw-flex tw-w-full tw-items-center tw-justify-between !tw-bg-opacity-90 tw-px-6 tw-py-6 tw-transition-all tw-duration-300 md:tw-px-20 xl:tw-px-32"
    :class="{ 'scrolled !tw-fixed': isScrolled }"
    :style="`
    ${
      menuVisible
        ? 'background-color: var(--c-secondary); color: var(--c-secondary);'
        : isScrolled || vars.fixedColorBool
          ? 'background-color: var(--c-secondary); color: var(--c-text-primary);'
          : 'background-color: transparent;'
    }
    color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'};
    z-index: 1001;
  `"
  >
    <!-- Sol Butonlar - Menü açıksa gizle -->
    <div class="tw-hidden tw-gap-4 lg:tw-flex">
      <nuxt-link
        v-for="(button, index) in buttons"
        :key="`button-${index}`"
        :class="[
          buttons.length >= 2 ? '' : 'tw-w-auto',
          menuVisible || isScrolled ? 'n-quaternary' : `n-${button.button_type}`,
          'tw-uppercase',
        ]"
        :to="button.button_link || '/'"
        :external="true"
      >
        {{ button.button_label }}
      </nuxt-link>
    </div>

    <!-- Logo -->
    <nuxt-link
      to="/"
      :external="true"
      :class="[
        'n-link tw-transition-all tw-duration-1000 tw-ease-in-out',
        'md:tw-absolute md:tw-left-1/2 md:tw--translate-x-1/2',
      ]"
    >
      <template v-if="company.company_key === 'harrisonshomes'">
        <div class="tw-w-40 md:tw-w-64">
          <img :src="logo" :style="`width: 100%;`" />
        </div>
      </template>
      <template v-else>
        <div class="tw-w-44 tw-max-w-64">
          <LibraryImage :src="logo" :h-ratio="2" :w-ratio="5" />
        </div>
      </template>
    </nuxt-link>

    <!-- Sağ Burger Menü (v3’e özel) -->
    <button
      class="icon burger-menu tw-border-[1px]"
      @click="toggleBurgerMenuV3"
      :style="`
    border-color: var(--white);
    color: var(--white) !important;
  `"
    >
      <span :style="`background: var(--white);`"></span>
      <span :style="`background: var(--white);`"></span>
    </button>
  </div>

  <div
    v-if="variants.HEADER_4 === variant && menuVisible"
    class="nav-menu tw-fixed tw-inset-0 tw-z-40 tw-flex tw-flex-col tw-items-center tw-justify-between tw-overflow-y-auto !tw-bg-opacity-90 tw-pt-32"
    :style="`background-image: url('${vars.backgroundImage}'); background-size: cover; background-position: center; background-color: var(--c-${vars.backgroundColor})`"
  >
    <!-- Menü -->
    <div
      class="tw-flex tw-h-[70vh] tw-flex-col tw-items-start tw-justify-center tw-overflow-auto tw-px-3 xl:tw-h-screen"
    >
      <nav
        class="tw-max-h-full tw-overflow-auto tw-pb-12 lg:tw-pb-32"
        :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--white)'}`"
      >
        <ul class="tw-flex tw-flex-col tw-gap-4">
          <li
            v-for="(menuGroup, groupIndex) in allMenu[0]"
            :key="`menuGroupIndex-${groupIndex}`"
            class="nav-item tw-group tw-relative tw-duration-300"
            :style="`animation-delay: ${groupIndex * 0.2}s;`"
          >
            <div
              class="tw-flex tw-items-center tw-justify-start tw-text-white lg:tw-justify-center"
              @click="toggleSubMenu(groupIndex)"
            >
              <nuxt-link
                :to="menuGroup.has_sub_menu ? '' : menuGroup.url"
                :target="menuGroup.is_open_new_tab ? '_blank' : ''"
                :external="true"
                class="n-link tw-duration-400 tw-text-start hover:tw-text-[var(--c-primary)] xl:tw-text-center"
              >
                <h2>{{ menuGroup.name }}</h2>
              </nuxt-link>
            </div>
            <!-- Sub Menu -->
            <ul
              v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
              class="tw-overflow-hidden tw-transition-all tw-duration-1000 tw-ease-in-out"
              :class="openSubMenu === groupIndex ? 'tw-max-h-96' : 'tw-max-h-0'"
            >
              <li
                v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
                :key="`${subMenuIndex}-subMenu-${groupIndex}`"
                class="tw-pb-2 tw-pt-0 tw-text-center"
              >
                <nuxt-link
                  class="n-link tw-block tw-duration-300 hover:!tw-text-[var(--c-primary)]"
                  :external="true"
                  :to="subMenu.url"
                  :target="subMenu.is_open_new_tab ? '_blank' : ''"
                  :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--white)'}`"
                >
                  <h6>{{ subMenu.name }}</h6>
                </nuxt-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      <nuxt-link
        v-if="buttons.length"
        :to="buttons[0].button_link || '/'"
        :external="true"
        class="n-primary tw-mt-2 tw-flex tw-w-auto tw-items-start lg:tw-hidden"
      >
        {{ buttons[0].button_label }}
      </nuxt-link>
    </div>

    <!-- Mobilde buton -->
    <div class="tw-flex tw-w-full tw-justify-start tw-px-6 tw-pb-12 lg:tw-hidden"></div>
  </div>

  <!-- =============== /HEADER_4 (YENİ) =============== -->
</template>
<script lang="ts">
import { mapState } from 'pinia';
import { MenuTypes, ViewTypes } from '~/constants/ui.constants';
import { ComponentMixin } from '~/mixins/component.mixin';
import NcButton from '~/components/common/inputs/NcButton.vue';
import { useWebsiteStore } from '~/units/website/store';
import { useCoreStore } from '~/units/core/store';
import NavigationBanner from '~/components/theme4/components/NavigationBanner';
import Button from '~/components/common/Button.vue';
type Menu = {};

export default defineNuxtComponent({
  name: 'Theme4BaseHeaderOne',
  components: { NcButton, NavigationBanner },

  mixins: [ComponentMixin],

  props: {
    component: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      ViewTypes,
      menuVisible: false,
      isScrolled: false,
      openSubMenu: null as number | null,
      variants: {
        HEADER_1: 'HEADER_1',
        HEADER_2: 'HEADER_2',
        HEADER_3: 'HEADER_3',
        HEADER_4: 'HEADER_4',
      },
    };
  },

  computed: {
    ...mapState(useWebsiteStore, ['headerMenuItems']),
    ...mapState(useCoreStore, ['isAnythingOnTopVisible']),

    headerMenu() {
      return this.headerMenuItems as Menu[];
    },

    // v3'ün butonları (Theme6 mantığı)
    buttons(): any[] {
      return (this as any).groupedVariables?.buttons || [];
    },

    routeUrl() {
      const route = useRoute();
      return route.path;
    },

    allMenu() {
      const period = 9;
      const columnsCount = Math.ceil(this.columnOneMenu.length / period);
      const groups: any[] = [];

      for (let i = 0; i < columnsCount; i++) {
        groups[i] = [];
        for (let p = 0; p < period; p++) {
          const index = period * i + p;
          if (this.columnOneMenu[index]) {
            groups[i].push(this.columnOneMenu[index]);
          }
        }
      }

      return groups;
    },

    columnOneMenu() {
      const content = (this as any).component.variables['column_one_content-text'];
      if (content === MenuTypes.HEADER_MENU) {
        return this.headerMenu;
      }
      return [];
    },

    navigationBanner() {
      return {
        isVisibleBool: (this as any).vars.bannerBool,
        backgroundColor: (this as any).vars.bannerBackgroundColor,
        descriptionText: (this as any).vars.bannerDescriptionText,
        buttonLinkUrl: (this as any).vars.bannerButtonLinkUrl,
        buttonLabelText: (this as any).vars.bannerButtonLabelText,
        buttonTypeText: (this as any).vars.bannerButtonTypeText,
        visibleAfterScrollBool: (this as any).vars.bannerVisibleAfterScrollBool,
      };
    },

    /* ====== YALNIZCA HEADER_3 ====== */
    logo() {
      const vars = (this as any).vars;
      if (this.menuVisible) {
        return (this as any).company.logo;
      } else if (this.isScrolled) {
        return (this as any).company.light_logo;
      } else if (!vars.fixedColorBool && !this.isScrolled) {
        return (this as any).company.logo;
      }
      return (this as any).company.light_logo;
    },

    navTextColor(): string {
      if (this.isScrolled) return 'primary';
      return (this as any).vars.navTextColor || 'secondary';
    },
    /* ====== /HEADER_3 ====== */
  },

  methods: {
    toggleSubMenu(index: number) {
      this.openSubMenu = this.openSubMenu === index ? null : index;
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;

      if (this.menuVisible) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 0;
    },

    /* ====== YALNIZCA HEADER_3 ====== */
    toggleBurgerMenuV3() {
      this.menuVisible = !this.menuVisible;
      this.toggleActiveClassV3();
      document.body.classList.toggle('no-scroll', this.menuVisible);
    },
    toggleActiveClassV3() {
      const burgerMenu = document.querySelector('.burger-menu');
      burgerMenu?.classList.toggle('active');
      burgerMenu?.querySelectorAll('span').forEach((span) => span.classList.toggle('active'));
    },
    closeBurgerMenuV3() {
      this.menuVisible = false;
      const burgerMenu = document.querySelector('.burger-menu');
      burgerMenu?.classList.remove('active');
      burgerMenu?.querySelectorAll('span').forEach((span) => span.classList.remove('active'));
      document.body.classList.remove('no-scroll');
    },
    onKeydownEsc(e: KeyboardEvent) {
      if ((this as any).variant === this.variants.HEADER_3 && e.key === 'Escape' && this.menuVisible) {
        this.closeBurgerMenuV3();
      }
    },
    /* ====== /HEADER_3 ====== */
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('keydown', this.onKeydownEsc);
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('keydown', this.onKeydownEsc);
    document.body.classList.remove('no-scroll');
  },
});
</script>

<style>
.no-scroll {
  overflow: hidden;
}

/* ====== HEADER_3'e özel stil ====== */
.nav-item {
  transform: translateY(-12px);
  opacity: 0;
  animation: v3FadeInUp 0.35s forwards;
}
@keyframes v3FadeInUp {
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

button.icon {
  display: flex;
  flex-direction: column;
  gap: 5px;
  background: transparent;
  cursor: pointer;
  align-items: center;
  width: 56px;
  height: 56px;
  justify-content: center;
  border: 1.3px solid inherit;
  border-radius: 8px;
}
button.icon > span {
  height: 2px;
  width: 16px;
  background: inherit;
  border-radius: 30px;
  transition: all 0.3s linear;
}
button.icon > span:nth-child(2) {
  width: 12px;
  margin-left: 3px;
}
button.icon:hover > span {
  width: 11px;
  margin-left: 5px;
}
button.icon.active:hover > span {
  width: 16px;
  margin-left: 0;
}
button.icon:hover > span:nth-child(2) {
  width: 16px;
  margin-left: 0;
}
button.icon.active {
  border-color: #fff !important;
}
button.icon.active > span {
  transform: rotate(45deg);
  margin-bottom: -2px;
}
button.icon.active > span.active {
  background: #fff !important;
}
button.icon.active > span:nth-child(2) {
  width: 16px;
  margin-left: 0;
  margin-top: -5px;
  transform: rotate(-45deg);
  margin-bottom: 0;
}
/* ====== /HEADER_3 ====== */
</style>
